import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const TableFooterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  justifyContent: "space-between",
  alignItems: "center",
}));
